<template>
  <van-sticky>
    <div class="head">重要通知：香港新彩20：15开奖</div>
  </van-sticky>
  <van-swipe indicator-color="white" :autoplay="3000" class="swipe">
    <van-swipe-item v-for="(item, index) in swipeList" :key="index">
      <img :src="item.src" alt="" />
    </van-swipe-item>
  </van-swipe>
  <van-notice-bar
    left-icon="volume-o"
    text="近期澳彩官网遭受黑客组织恶意攻击，导致开奖结果同步异常跳转至第三方出现多种开奖结果，开奖验证请认准澳彩官方网站或者留意相关公告！"
  />
  <div class="navs">
    <div v-for="(item, index) in navs" :key="index" @click="onClick(item)">
      <img :src="item.icon" />
      {{ item.name }}
    </div>
  </div>
</template>

<script setup>
import typeTableIcon from "@/assets/img/typeTableIcon.png";
import logo from "@/assets/img/logo.png";
import { useRouter } from "vue-router";
import { showDialog } from "vant";
import { ref } from "vue";
import { drawHttp } from "../request/index";
const router = useRouter();

const getUrl1 = (iconName) => {
  return new URL(`../assets/swipes/${iconName}`, import.meta.url).href;
};
const swipeList = ref([
  { src: getUrl1("1.jpg") },
  { src: getUrl1("2.jpg") },
  { src: getUrl1("3.png") },
  { src: getUrl1("4.jpg") },
]);

const getUrl = (iconName) => {
  return new URL(`../assets/img2/${iconName}.png`, import.meta.url).href;
};

function onClick(item) {
  if (item.url) {
    window.open(item.url, "_blank");
  } else if (item.tuku) {
    const el = document.querySelector("#tuku");
    if (el) {
      el.scrollIntoView();
    }
  } else {
    showDialog({ message: "敬请期待", showCancelButton: false });
  }
}

const navs = [
  { name: "彩色图库", icon: getUrl("1"), tuku: true },
  { name: "黑白图库", icon: getUrl("2"), tuku: true },
  {
    name: "号码走势",
    icon: getUrl("6"),
    url: "kaijianglishi.ab0149.top/",
  },
  {
    name: "挑码助手",
    icon: getUrl("9"),
    url: "kaijiang.ab0149.top/#/tmzs",
  },
];
</script>

<style lang="scss" scoped>
.swipe {
  img {
    width: 100%;
  }
}
.head {
  width: 100vw;
  // display: flex;
  // align-items: center;
  // justify-content: space-between;
  padding: 6px 10px;
  // background-color: #2ab0f2;
  background: #f13131;
  display: flex;
  flex: 1;
  justify-content: space-between;
  color: #fff;
  font-size: 18px !important;
  font-weight: bold;
  line-height: 40px;
}
.navs {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  align-items: center;
  justify-content: space-around;
  padding: 10px 0;
  background-color: #fff;
  grid-gap: 12px;
  div {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    color: #333;
    cursor: pointer;
    img {
      margin-bottom: 6px;
      width: 50%;
    }
    &:hover {
      color: #f13131;
    }
  }
}
</style>